import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CancelConfirmDialog = ({ open, onKeep, onConfirm }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <Dialog open={open} onClose={onKeep} className="cash-wallet-cancel-dialog">
            <DialogTitle className="cash-wallet-cancel-title">{t('CancelConfirm.Title')}</DialogTitle>
            <DialogContent>
                <DialogContentText className="cash-wallet-cancel-body">{t('CancelConfirm.Body')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="cash-wallet-cancel-keep" variant="outlined" color="primary" onClick={onKeep}>
                    {t('CancelConfirm.Keep')}
                </Button>
                <Button className="cash-wallet-cancel-confirm" variant="outlined" color="danger" onClick={onConfirm}>
                    {t('CancelConfirm.Confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelConfirmDialog;
